import React, { useState } from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import moment from 'moment';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import {
  commonMobileMauReDownDefaultFilterValue,
  handleActiveuserFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import type { pointInterId } from '@/pages/home/utils/buriedPoint';
import { SegmentOption } from '@intelligence/pages/PCConsoleBenchmark/types';
import { searchShortCutGames } from '@intelligence/services/filter';
import MobileCompetitorContent from '../MobileCompetitorContent';
import useSenTowerTag from '@intelligence/hooks/useSenTowerTag';
import { defaultActiveuserApiParams } from '@intelligence/pages/TopCharts/MobileGames/ActiveUsers/constant';

// 默认一页展示个数
const DEFAULT_PAGE_SIZE = 10;

interface IMetricsTableCompProps {
  // 默认勾选的游戏列表
  defaultSelection: object[];
  // 默认勾选的游戏id列表
  defaultSelectionIds: string[];
  // 高亮的游戏列表
  gameHightList: string[];
  pageLogMes: pointInterId;
  shortcutList: SegmentOption[];
}

export default function StudioMobileCompetitor(props: IMetricsTableCompProps) {
  const { defaultSelectionIds, defaultSelection, gameHightList, shortcutList } = props;
  const entityType = 'mobile';
  const { tagLoading, tagConfig } = useSenTowerTag({});
  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.common,
  });

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.mobileActiveuser?.type,
  });

  // 当前选中的快捷
  const [selectedShortcutActive, setSelectedShortcutActive] = useState<string[]>([shortcutList?.[0]?.value]);

  const defaultFilterValue = {
    ...commonMobileMauReDownDefaultFilterValue,
    [filterKeyMap.ALL_Games]: {
      value: defaultSelectionIds,
      keywords: '',
      isSearchAll: true,
      checkedList: defaultSelection,
    },
    // [filterKeyMap.METRICTABLE_DEVICE]: {
    //   value: getDeviceValuesByPageId(pageId),
    // },
    [filterKeyMap.RANGE_TIME]: {
      type: 'date',
      value: ['', ''],
    },
  };

  const filterCfg: TopchartFilterCfgType = {
    filterKeyList: [
      filterKeyMap.RANGE_TIME,
      filterKeyMap.ALL_Games,
      filterKeyMap.REGION,
      // filterKeyMap.METRICTABLE_DEVICE,
      filterKeyMap.DATASOURCE,
      filterKeyMap.PLATFORM,
    ],
    companyFilterParams: {
      entity_type: entityType,
      source: 'sensortower',
      metric: 'dau',
      region_type: 'region',
      regions: ['global'],
      granularity: 'daily',
      start_date: '2024-01-27',
      end_date: '2024-02-25',
      data_sources: ['sensortower', 'appannie'],
      page_size: 500,
      search_name: '',
      page: 1,
      source_metric: {
        sensortower: ['dau'],
      },
    },
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
      [filterKeyMap.RANGE_TIME]: {
        type: 'date',
        value: [moment().subtract(30, 'd'), moment().subtract(1, 'd')],
      },
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: false,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: false,
      entityType,
      sensorTowerTagConfig: tagConfig,
      dataSourceShowDatabrain: false,
      [filterKeyMap.ALL_Games]: {
        selectGameBtnText: 'Competitor',// TODO翻译
        params: { entity_type: entityType, hasReleaseTime: false, game_type: 'current_game' },
        chooseUpNum: 9,
        entityKey: 'mobile_id',
        isStudio: true,
        fixedSelectionGame: gameHightList,
        hasShortCut: true,
        shortcutList,
        onShortcutClick: (type: string, isActive: boolean) => {
          // 因多选数据会有问题，改成单选
          setSelectedShortcutActive(() => {
            if (isActive) {
              // 如果 isActive 为 true，将 type 添加到 selectedShortcutActive 中
              return [type];
            }
            // 如果 isActive 为 false，从 selectedShortcutActive 中移除 type
            return [];
          });
        },
        shortcutAddGame: false,
        selectedShortcutActive,
        searchAllGamesApi: searchShortCutGames,
        isShowShortcutTitle: false,
        notSelectTips: 'dbi_studio_competitor_game_selection_empty',
        transferModalClassName: 'dbh-studio-competitor-transfer-modal',
        setSelectedShortcutActive,
        shortCutNameEn: true
      },
    },
    showConfirmButton: true,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleActiveuserFilterParamsToApi,
  };

  const defaultParams = {
    ...defaultActiveuserApiParams,
    entity_type: entityType,
    metrics: ['dau', 'revenue', 'download', 'arpu'], // 页面固定
    order_metric: 'dau',
    ratio_type: 0, // 环比排序是1 ，默认值排序是0
    order: 'desc',
    data_sources: ['sensortower'],
    order_source: 'sensortower',
    platforms: ['appstore', 'googleplay'], // DataBrain 为  unified
    b_data_brain: 1,
    filter_ids: defaultSelectionIds?.length ? defaultSelectionIds : [''],
    page_size: DEFAULT_PAGE_SIZE,
  };


  return (
    <MobileCompetitorContent
      filterCfg={filterCfg}
      filterLoading={filterLoading || tagLoading}
      getDeliveryTipValue={'ActiveUsersTopChartsDeliveryTip'}
      topchartsNameParams={'active users'}
      rangeTimeComponentDefault={latestTimeTypeHasData}
      defaultParams={defaultParams}
    />
  );
}
